/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './settings/spos/spos_settings';
import './settings/rtl/rtl_settings';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "DeviceProfileV2": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "shared": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "version": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "sposSettings": {
                            "type": ".squareup.devicesettings.profiles.v2.model.settings.spos.SPOSSettings",
                            "id": 5
                          },
                          "rtlSettings": {
                            "type": ".squareup.devicesettings.profiles.v2.model.settings.rtl.RTLSettings",
                            "id": 6
                          }
                        },
                        "nested": {
                          "settings": {
                            "oneof": ["sposSettings", "rtlSettings"]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.DeviceProfileV2) {
  $root.addJSON(jsonData);
}

/**
 * DEPRECATED! DO NOT USE! Use /shared/device_profile.proto instead.
 *
 * SOURCE DeviceProfileV2 @ squareup/devicesettings/profiles/v2/model/device_profile.proto at 16:1
 */
export const DeviceProfileV2 = $root.lookupType('squareup.devicesettings.profiles.v2.model.DeviceProfileV2');
fixType(DeviceProfileV2);
Builder.createAndAttachToType(DeviceProfileV2);